import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export function MissedCheckInCard(): JSX.Element {
  return (
    <div className=" w-full min-h-28 flex  flex-col items-center justify-center rounded-lg gap-2 p-6 border border-dashed border-[#D9D9D9] bg-primary-light">
      <ExclamationCircleIcon className="h-6 w-6 text-primary-dark" />
      <span className="text-gray-600 text-center text-sm">
        Missed Check-In. No Update Provided
      </span>
    </div>
  );
}
